
import PageContext from 'global_state/context/PageContext'
import { useContext } from 'react'
import { PageType } from 'types/PageI';
import Title from 'components/Title';

import FormSCSS from 'assets/scss/Form.module.scss'
import SCSS from 'assets/scss/CreateAccount.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'

import content from 'languages/VerifyEmail.json'
import UserContext from 'global_state/context/UserContext';


interface VerifyEmailProps {
    path?: "new" | "online"
}
function VerifyEmail(props: VerifyEmailProps) {
    const {page, dispatchPage}  = useContext(PageContext)
    const {user, dispatchUser}  = useContext(UserContext)
    // console.log(user);
    
    let language = page.settings.language

    const handleSubmit = (event) => {
        event.preventDefault()
        // console.log(event);
        // console.log(user);
        
        if (props.path === "online") {
            dispatchPage({type: "render", payload: {page: PageType.create_password}})
            return 
        }

        dispatchPage({type: "render", payload: {page: PageType.log_in_form}})
        
    }

    return(
        <div className={[SCSS.verify_email, FormSCSS.form_wrapper].join(" ")}> 
            <Title back_arrow={false} title={content[language].title}></Title>
            <form
                className={FormSCSS.form}
                onSubmit={(event) => {handleSubmit(event)}}>
                
                <div>{content[language].text}</div>

                <button className={[AppSCSS.button, AppSCSS.red].join(" ")} type="submit">{content[language].button_submit}</button>
            </form>
        </div>
    )
}

export default VerifyEmail